import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/app/blog/_styles/blog.css");
